import http from 'utils/http';
import { getTelephonyProvidersUrl } from './apiUrls';
import { TelephonyProvidersResponse } from './types';

export async function getTelephonyProviders(params?: any): Promise<TelephonyProvidersResponse> {
  return http.get(getTelephonyProvidersUrl(), params);
}
